<template>
  <div class="">
    <div class="bg-[#1E293B]">
      <div class="homepage">
        <h1 class="title">WX-One Pricing Calculator</h1>
        <h2 class="subtitle font-base">
          Estimate the cost for your architecture solution.
        </h2>
        <p class="description md:font-base">
          Configure a cost estimate that fits your unique business or personal needs with WX-One products and services.
        </p>
        <router-link to="/calculator">
          <PrimaryButton :text="'Create Estimate'" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/PrimaryButton.vue";

export default {
  components: { PrimaryButton },
};
</script>

<style lang="postcss" scoped></style>
